"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateBudget = void 0;
const calculateBudget = (calorieBudget) => {
    const calories = calorieBudget.fats * 9 +
        calorieBudget.carbohydrates * 4 +
        calorieBudget.proteins * 4;
    return {
        ...calorieBudget,
        calories,
        fibers: parseInt(String(14 * (calories / 1000))),
    };
};
exports.calculateBudget = calculateBudget;
//# sourceMappingURL=calculateBudget.js.map